import { render, staticRenderFns } from "./DocHubCloudflareVideoButton.vue?vue&type=template&id=29430a42"
import script from "./DocHubCloudflareVideoButton.vue?vue&type=script&lang=js"
export * from "./DocHubCloudflareVideoButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports